module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(_vm.choosen.terms && _vm.choosen.terms.length) ? _c('div', {
    staticClass: "terms-list"
  }, _vm._l((_vm.choosen.vocabularies), function(vocabulary) {
    return _c('div', {
      key: vocabulary.id,
      staticClass: "terms-group form-group clearfix"
    }, [_c('label', {
      staticClass: "terms-group-name pull-left"
    }, [_vm._v("\n                Vocabulary\n                "), _c('strong', [_vm._v("\"" + _vm._s(vocabulary.name) + "\":")])]), _vm._v(" "), _vm._l((_vm.choosen.terms), function(term) {
      return [(term.vocabularyId === vocabulary.id) ? _c('span', {
        key: term.id,
        staticClass: "terms-badge badge badge-pill badge-info"
      }, [_vm._v("\n                  " + _vm._s(term.name) + "\n                  "), _c('span', {
        staticClass: "badge-delete-icon terms-badge-close",
        on: {
          "click": function($event) {
            return _vm.deleteTerm(term.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-times"
      })])]) : _vm._e()]
    })], 2)
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Vocabulary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.vocabulariesOptionsDefault,
      "search-function": _vm.vocabularySearch,
      "label": "name"
    },
    model: {
      value: (_vm.newTerm.vocabulary),
      callback: function($$v) {
        _vm.$set(_vm.newTerm, "vocabulary", $$v)
      },
      expression: "newTerm.vocabulary"
    }
  })], 1)]), _vm._v(" "), (_vm.newTerm.vocabulary) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Terms")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.termsLoading) ? _c('spinner', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "size": "sm"
    }
  }) : _vm._e(), _vm._v(" "), _c('vue-select', {
    ref: "refTermsModel",
    attrs: {
      "multiple": "",
      "filterable": false,
      "options": _vm.newTerm.termsOptions,
      "label": "id"
    },
    on: {
      "search": _vm.onTermsSearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_vm._v("\n                  " + _vm._s(option.name) + "\n                ")]
      }
    }, {
      key: "selected-option",
      fn: function(option) {
        return [_vm._v("\n                  " + _vm._s(option.name) + "\n                ")]
      }
    }], null, false, 3155861965),
    model: {
      value: (_vm.newTerm.terms),
      callback: function($$v) {
        _vm.$set(_vm.newTerm, "terms", $$v)
      },
      expression: "newTerm.terms"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("\n                  type to search...\n                ")])], 2)], 1)]) : _vm._e(), _vm._v(" "), (_vm.newTerm.vocabulary && _vm.newTerm.terms && _vm.newTerm.terms.length) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addNewTerms
    }
  }, [_vm._v("Add")])])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Taxonomy")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34d02d30","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/global/components/TermsEditor.vue
// module id = 862
// module chunks = 0